import { inject, Injectable } from '@angular/core';

import { ACQUISITION_SOURCES, ROUTES } from '@core/constants';
import {
  AcquisitionSourceOption,
  AdminCustomerData,
  DocumentTypeOption,
  ICustomersResponse,
  IResponseHttp,
} from '@core/models';
import { ApiService, LookupService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  readonly api = inject(ApiService);
  private readonly lookupService: LookupService = inject(LookupService);

  async getCustomers(params?: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<ICustomersResponse> {
    const query = new URLSearchParams();

    if (params?.page) {
      query.set('page', params.page.toString());
    }

    if (params?.pageSize) {
      query.set('pageSize', params.pageSize.toString());
    }

    if (params?.search?.trim()) {
      query.set('search', params.search.trim());
    }

    const url = `${ROUTES.ADMIN_GET_CUSTOMERS}?${query.toString()}`;

    const result = await this.api.get<IResponseHttp>(url);

    return result.payload;
  }

  async updateCustomer(id: string, changes: Partial<AdminCustomerData>): Promise<void> {
    const payload = {
      fullName: changes.name ,
      documentNumber: changes.documentNumber,
      documentType: changes.documentType,
      phone: changes.phone,
      address: changes.address,
      email: changes.email,
      acquisitionSource: changes.acquisitionSource,
    };

    for (const key in payload) {
      if (payload[key as keyof typeof payload] === undefined) {
        delete payload[key as keyof typeof payload];
      }
    }
    await this.api.patch(`${ROUTES.ADMIN_UPDATE_CUSTOMER(id)}`, payload);

  }

  getAcquisitionSourceOptions(): AcquisitionSourceOption[] {
    return ACQUISITION_SOURCES;
  }

  async getDocumentTypeOptions(): Promise<DocumentTypeOption[]> {
    return (await this.lookupService.getDocumentType()) as DocumentTypeOption[];
  }
}
